'use strict';

module.exports = [require('./to')];


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/mathjs/lib/function/unit/index.js
// module id = YPC6
// module chunks = 15